<template>
  <ul class="list-disc pl-4">
    <li v-for="(str, index) in strings" :key="index">
      {{ str }}
    </li>
  </ul>
</template>

<script setup lang="ts">
const props = defineProps<{
  value: string[]
}>()

const strings = props.value ?? []
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding-left: 1rem;
}
</style>
